import React from 'react';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
const stats = [{
  value: '+1.200',
  label: 'docentes'
}, {
  value: '6',
  label: 'tomos listos'
}, {
  value: '240 h',
  label: 'ahorradas / año'
}, {
  value: '4.9/5',
  label: '⭐ valoración'
}];
export function Stats() {
  return <section className="border-y border-navy/10 bg-white px-4 py-8" data-id="element-187" data-mp="2nv7dvyphyhzc">
      <div className="mx-auto max-w-4xl" data-id="element-188" data-mp="2972zh6xh8smd">
        <div className="mb-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-semibold text-navy/70 sm:text-sm" data-id="element-189" data-mp="296b5u1nfx4yq">
          <span className="inline-flex items-center gap-1.5" data-id="element-190" data-mp="2088x0zxgt80w">
            <ShieldCheckIcon className="h-4 w-4 text-teal" data-id="element-191" data-mp="205mrt6y1r4lu" /> Garantía 7 días
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-192" data-mp="254g26qi1efhs">
            <LockIcon className="h-4 w-4 text-brandpurple" data-id="element-193" data-mp="1qal2a9zv00iq" /> Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-194" data-mp="1v7bfmpka4i0g">
            <CreditCardIcon className="h-4 w-4 text-magenta" data-id="element-195" data-mp="55repx9wlegm" /> Múltiples medios
          </span>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4" data-id="element-196" data-mp="6wwoxjrftxk">
          {stats.map(s => <div key={s.label} className="rounded-2xl bg-cream px-3 py-4 text-center" data-id="element-197" data-mp="e661z26fh3mr">
              <div className="font-display text-2xl font-black text-navy sm:text-3xl" data-id="element-198" data-mp="a5w0a1po4zdp">
                {s.value}
              </div>
              <div className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-navy/55 sm:text-xs" data-id="element-199" data-mp="3ikw83a1hdb9z">
                {s.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}